<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Create Booking</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p>
      <b>{{ scheduledEvent.name }}</b>
    </p>

    <hr>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="bookViaClimberApp" id="bookViaClimberAppTrue"
               [(ngModel)]="bookViaClimberApp"
               [value]="true">
        <label class="form-check-label" for="bookViaClimberAppTrue">
          Book participant via Climber App to collect payment and participant details
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="bookViaClimberApp" id="bookViaClimberAppFalse"
               [(ngModel)]="bookViaClimberApp"
               [value]="false">
        <label class="form-check-label" for="bookViaClimberAppFalse">
          Book participant directly onto event without collecting payment or additional participant details
        </label>
      </div>
    </div>

    <ng-container *ngIf="bookViaClimberApp !== null">
      <hr>

      <div class="form-group" *ngIf="bookViaClimberApp">
        <label for="numParticipantsSelect">Number of Participants</label>
        <select class="custom-select" id="numParticipantsSelect"
                [(ngModel)]="selectedNumParticipants">
          <option *ngFor="let numParticipantsOption of getNumParticipantsOptions()"
                  [ngValue]="numParticipantsOption">
            {{ numParticipantsOption }}
          </option>

        </select>
      </div>

      <div class="form-group">
        <label for="searchCustomersInput">
          <ng-container *ngIf="bookViaClimberApp === true">
            Primary Customer for Booking (Optional)
          </ng-container>
          <ng-container *ngIf="bookViaClimberApp === false">
            Participant
          </ng-container>
        </label>
        <input type="text" class="form-control" id="searchCustomersInput"
               placeholder="Search by email, name, barcode, or telephone"
               [(ngModel)]="search"
               (ngModelChange)="handleCustomerFilterChange()">
      </div>

      <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
      <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
           *ngIf="(selectedCustomer === null) && hasSearchInput()">

        <ng-container *ngIf="hasSearchInput()">

          <table class="table table-bordered table-hover">
            <tbody *ngIf="!customerResultsPresent()">
              <tr>
                <td colspan="99">
                  {{ loadingCustomers ? 'Loading...' : 'No results' }}
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="customerResultsPresent()">
              <tr style="cursor:pointer"
                  *ngFor="let customer of customerList"
                  (click)="selectCustomer(customer)">
                <td>
                  {{ customer.first_name }} {{ customer.last_name }}
                  <span class="text-muted">
                    {{ dateStringFromISO8601(customer.birthday )}}
                    <span *ngIf="customer.email">- {{ customer.email }}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
            Only recently-active customers are being shown.
            <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
              Expand search to all customers.
            </a>
          </div>

        </ng-container>

      </div>

      <div class="form-group form-check" *ngIf="bookViaClimberApp === false">
        <input type="checkbox" class="form-check-input"
               id="sendConfirmationEmail" name="sendConfirmationEmail"
               [(ngModel)]="sendConfirmationEmail">
        <label class="form-check-label" for="sendConfirmationEmail">
          Send reservation confirmation email
        </label>
      </div>

      <div class="form-group form-check" *ngIf="bookViaClimberApp === false">
        <input type="checkbox" class="form-check-input"
               id="checkInImmediately" name="checkInImmediately"
               [(ngModel)]="checkInImmediately">
        <label class="form-check-label" for="checkInImmediately">
          Check participant into this event immediately
        </label>
      </div>

      <div class="form-group form-check" *ngIf="bookViaClimberApp === false">
        <input type="checkbox" class="form-check-input"
               id="includesEntry" name="includesEntry"
               [(ngModel)]="includesEntry">
        <label class="form-check-label" for="includesEntry">
          Booking includes facility entry
        </label>
        <small class="form-text text-muted">
          If checked, this booking counts as an entry method for facility check-in.
        </small>
      </div>

      <div class="alert alert-info" *ngIf="bookViaClimberApp === false">
        This will bypass any fees, add-ons, additional participant questions, and capacity limits that pertain to this event.
      </div>

      <div class="alert alert-warning mt-3 mb-0" role="alert"
           *ngIf="bookViaClimberApp === false && checkInImmediately && startsMoreThanOneHourFromNow()">
        This event starts {{ getTimeUntilEventDisplay() }} from now. Are you sure you want to check the participant in now?
      </div>
    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <a class="btn btn-primary"
       *ngIf="(bookViaClimberApp === true) && !loadingSubmit"
       href="#"
       (click)="$event.preventDefault();handleGoToScheduler();">
      Go to Scheduler
    </a>
    <button class="btn btn-primary" type="button"
            *ngIf="(bookViaClimberApp === false) && !loadingSubmit"
            [disabled]="!selectedCustomer"
            [class.disabled]="!selectedCustomer"
            (click)="handleCreateBooking()">
      Create Booking
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
